import * as React from 'react';

import styles from './secondary-title.module.css';

interface SecondaryTitleProps {
    title?: string;
    withMargin?: boolean;
    noBorderBottom?: boolean;
    children?: React.ReactNode;
}

export const SecondaryTitle: React.FC<SecondaryTitleProps> = ({ title, children, withMargin = true, noBorderBottom = false }) => (
    <div
        className={`${styles.SecondaryTitle} ${
            withMargin ? styles.SecondaryTitleWithMargin : styles.SecondaryTitleNoMargin
        } ${noBorderBottom ? styles.NoBorderBottom : ''} titleSelectReactLoading`}
    >
        {!children && title && <h2 data-qa={`secondary-title-${title}`}>{title}</h2>}
        {children}
    </div>
);
